import {
  useBoolean,
  InputProps,
  InputRightElement,
  IconButton,
} from '@chakra-ui/react'
import React from 'react'
import { VisibilityOn, VisibilityOff } from '../../../icons'
import { Input } from '../Input'
import { IFormValidationProps } from '../hooks'

export const PasswordInput = React.forwardRef<
  HTMLInputElement,
  IFormValidationProps & InputProps
>(({ ...rest }, ref) => {
  const [showPassword, setShowPassword] = useBoolean(false)

  const handleShowPassword = setShowPassword.toggle

  return (
    <Input
      autoComplete="false"
      data-testid="password-input"
      ref={ref}
      rightElement={
        <InputRightElement h="full">
          <IconButton
            _hover={{
              bg: 'inherit',
              border: 'inherit',
            }}
            aria-label={showPassword ? 'Show' : 'Hide'}
            border="inherit"
            data-testid="password-input-icon-button"
            icon={showPassword ? <VisibilityOn /> : <VisibilityOff />}
            onClick={handleShowPassword}
            variant="ghost"
          />
        </InputRightElement>
      }
      type={showPassword ? 'text' : 'password'}
      {...rest}
    />
  )
})
